@if (impersonating) {
<div class="impersonating-bar">
  <p>
    You are currently impersonating: <b>{{ impersonatedUser.Email }}</b>
    <button mat-raised-button (click)="stopImpersonation()" class="impersonating-btn">
      <mat-icon>pan_tool</mat-icon>
      Stop Impersonation
    </button>
  </p>
</div>
}
<app-top-navbar (showSplitpane)="toggleSplitpane($event)"></app-top-navbar>
<!-- <div
	*ngIf="showSplitpane && layoutService.screenSize <= ScreenSize.TABLET"
	class="mobile-side-container">
	<tools-side-menu (CloseRequested)="closeSideNav()"></tools-side-menu>
</div> -->
<div style="width: 100%; height: 100%">
  <!-- <mat-drawer-container class="container" autosize>
      <mat-drawer #drawer class="sidenav" mode="side">
        <p>Auto-resizing sidenav</p>
        <button mat-raised-button>
          Toggle extra text
        </button>
      </mat-drawer>
    
      <div class="sidenav-content">
        <button type="button" mat-button (click)="drawer.toggle()">
          Toggle sidenav
        </button>
      </div>
    
    </mat-drawer-container> -->

  <!-- <div *ngIf="layoutService.screenSize <= ScreenSize.TABLET">
		<router-outlet
			id="main"
			main></router-outlet>
	</div> -->
  @if (layoutService.screenSize > ScreenSize.TABLET) {
  <mat-drawer-container [hasBackdrop]="false" contentId="main" when="md">
    @if (collapse) {
    <mat-drawer [mode]="'side'" [opened]="showSplitpane">
      <tools-side-menu 
        (CloseRequested)="closeSideNav()"
        (sizeChanged)="onSizeChanged()"
        >
      </tools-side-menu>
    </mat-drawer>
    } @else{
      <mat-drawer [mode]="'side'" [opened]="showSplitpane">
        <tools-side-menu 
          (CloseRequested)="closeSideNav()"
          (sizeChanged)="onSizeChanged()"
          >
        </tools-side-menu>
      </mat-drawer>
      }

    <!-- <ion-menu contentId="main" menuId="sidenavMenu" side="start">
        <div>
          <mat-list>
            <div *ngFor="let page of appPages; let i = index;">
              <div *ngIf="(page.mobileOnly && layoutService.screenSize <= ScreenSize.TABLET) ||
              (page.mobileOnly == false || page.mobileOnly == null)">
                <ion-menu-toggle menu="sidenavMenu" autoHide="false">
                  <mat-list-item *ngIf="page.subPages.length == 0"
                    routerDirection="root" 
                    [routerLink]="page.url" 
                    (click)="selectedIndex = i; page.func != null ? page.func() : null;"
                    [class.selected]="selectedIndex === i"
                    lines="none" 
                    detail="false">
                      <ion-icon slot="start" *ngIf="page.customIcon != null && page.customIcon" [src]="page.icon"></ion-icon>
                      <ion-icon slot="start" *ngIf="page.customIcon == null || !page.customIcon" [name]="page.icon + '-outline'"></ion-icon>
                      <mat-label>{{page.title}}</mat-label>
                  </mat-list-item>
                  <mat-accordion *ngIf="page.subPages.length > 0">
                    <mat-expansion-panel [expanded]="true">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <mat-label>{{page.title}}</mat-label>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <mat-list-item *ngFor="let subpage of page.subPages"
                        routerDirection="root" 
                        [routerLink]="subpage.url" 
                        (click)="selectedIndex = i"
                        [class.selected]="selectedIndex === i"
                        lines="none" 
                        detail="false">
                          <ion-icon slot="start" *ngIf="subpage.customIcon != null && subpage.customIcon" [src]="subpage.icon"></ion-icon>
                          <ion-icon slot="start" *ngIf="subpage.customIcon == null || !subpage.customIcon" [name]="subpage.icon + '-outline'"></ion-icon>
                          <mat-label>{{subpage.title}}</mat-label>
                      </mat-list-item>
                    </mat-expansion-panel>
                  </mat-accordion>
                </ion-menu-toggle>
              </div>
            </div>
          </mat-list>
        </div>
      </ion-menu> -->
    <mat-drawer-content>
      <router-outlet id="main" main></router-outlet>
    </mat-drawer-content>
  </mat-drawer-container>
  }
  <!-- <div>{{ showSplitpane }}</div> -->
</div>
<!-- </ion-app> -->
